import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { X, Plus, Mail } from "lucide-react";
import { RispostaBadge } from "@/lib/inviti";

const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

export function PartecipantiField({ value = [], onChange, collaboratori = [], invited }) {
  const [ext, setExt] = useState("");
  const collabIds = new Set(value.filter((p) => p.tipo === "collaboratore").map((p) => p.id));
  const esterni = value.filter((p) => p.tipo !== "collaboratore");
  const toggleCollab = (c) => onChange(collabIds.has(c.id)
    ? value.filter((p) => !(p.tipo === "collaboratore" && p.id === c.id))
    : [...value, { tipo: "collaboratore", id: c.id, nome: c.nome, email: c.email || "" }]);
  const addExt = () => {
    const v = ext.trim().toLowerCase();
    if (!isEmail(v) || value.some((p) => p.email === v)) return;
    onChange([...value, { tipo: "esterno", nome: v, email: v }]);
    setExt("");
  };
  return (
    <div className="grid gap-2" data-testid="partecipanti-field">
      <Label>Partecipanti</Label>
      {collaboratori.length > 0 && (
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {collaboratori.map((c) => (
            <label key={c.id} className="inline-flex items-center gap-2 text-sm cursor-pointer" title={c.email || "Senza email"}>
              <Checkbox data-testid={`partecipante-collab-${c.id}`} checked={collabIds.has(c.id)} onCheckedChange={() => toggleCollab(c)} />
              {c.nome}{!c.email && <span className="text-[10px] text-amber-600">(senza email)</span>}
              {invited && collabIds.has(c.id) && <RispostaBadge tid={`risposta-collab-${c.id}`} risposta={value.find((p) => p.tipo === "collaboratore" && p.id === c.id)?.risposta} />}
            </label>
          ))}
        </div>
      )}
      <div className="flex gap-2">
        <Input data-testid="partecipante-email-input" value={ext} onChange={(e) => setExt(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addExt(); } }} placeholder="Email esterno (es. presidente@ssd.it)" className="h-9" />
        <Button data-testid="partecipante-add-button" type="button" variant="outline" size="sm" className="gap-1" onClick={addExt} disabled={!isEmail(ext.trim())}><Plus className="h-3.5 w-3.5" /> Aggiungi</Button>
      </div>
      {esterni.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {esterni.map((p) => (
            <span key={p.email} data-testid={`partecipante-esterno-${p.email}`} className="inline-flex items-center gap-1 text-xs bg-slate-100 dark:bg-slate-800 rounded-full pl-2.5 pr-1 py-1">
              <Mail className="h-3 w-3 text-slate-400" />{p.email}
              {invited && <RispostaBadge tid={`risposta-esterno-${p.email}`} risposta={p.risposta} />}
              <button type="button" onClick={() => onChange(value.filter((x) => x.email !== p.email || x.tipo === "collaboratore"))} className="text-slate-400 hover:text-destructive"><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
